/**
 * Search modal
 */

const search = () => {
  const init = () => {
    const modalEl = document.querySelector('.js-search-modal');
    if (!modalEl) {
      return;
    }
    const dialog = new A11yDialog( modalEl );
    const openEls = document.querySelectorAll(
      `[aria-controls="${ modalEl.id }"]`
    );
    Array.from( openEls ).forEach( ( openEl ) => {
      openEl.addEventListener( 'click', ( e ) => {
        e.preventDefault();
        // toggle dialog
        const isModalOpen = dialog.shown;
        if (isModalOpen) {
          dialog.hide();
          return;
        }
        dialog.show();

      } );
    } );
    dialog.on( 'show', () => {
      Array.from( openEls ).forEach( ( openEl ) => {
        openEl.setAttribute( 'aria-expanded', 'true' );
      } );
    } );
    dialog.on( 'hide', () => {
      Array.from( openEls ).forEach( ( openEl ) => {
        openEl.setAttribute( 'aria-expanded', 'false' );
      } );
    } );
    const langMenu = document.getElementById('lang-menu');
    const menuToggle = document.getElementById('network-menu-toggle');

    const altCloseableEls = [];

    if (langMenu) {
      altCloseableEls.push(langMenu);
    }

    if (menuToggle) {
      altCloseableEls.push(menuToggle);
    }

    // close dialog when clicking altCloseableEls
    altCloseableEls.forEach((el) => {
      el.addEventListener('click', () => {
        dialog.hide();
      });
    });

  };
  init();
};

document.addEventListener('DOMContentLoaded', () => {
  search();
});
